import axios from 'axios';
import axiosInstance from './axiosInstance';

const URL = process.env.REACT_APP_API_URL;


// ฟังก์ชันเพื่อเรียก API สำหรับการเข้าสู่ระบบ
export const loginAPI = async (email, password) => {
  try {
    const response = await axiosInstance.post(`${URL}/api/user/login`, {
      email: email,
      password: password,
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error logging in', error);
    throw error;
  }
};

// ฟังก์ชันเพื่อเรียก API สำหรับการสมัครสมาชิก
export const registerUserAPI = async (userData) => {
  try {
    const response = await axiosInstance.post(`${URL}/api/user/register`, userData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.data.status) {
      console.log('Registration successful:', response.data);
      return response.data;
    } else {
      console.error('Registration failed:', response.data.error?.message || 'Unknown error');
      throw new Error(response.data.error?.message || 'Unknown error');
    }
  } catch (error) {
    console.error('Error during registration:', error);
    throw error;
  }
};

// ฟังก์ชันเพื่อเรียก API สำหรับดึงข้อมูล dropdown
export const fetchDropdownDataAPI = async () => {
  try {
    const response = await axiosInstance.get(`${URL}/api/user/getCourseData`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = response.data;

    if (data.status) {
      console.log('Dropdown Data:', data);
      return {
        majors: data.data?.majors || [],
        years: data.data?.years || [],
        generations: data.data?.generations || [],
        course_names: data.data?.course_names || [],
        subjects: data.data?.subjects || [],
        categorys: data.data?.categorys || []
      };
    } else {
      throw new Error(data.error?.message || 'Unknown error');
    }
  } catch (error) {
    if (error.response) {
      console.error('API Error Response:', error.response.data);
      throw new Error(`API Error: ${error.response.data?.message || 'Unknown error'}`);
    } else if (error.request) {
      // ไม่ได้รับการตอบกลับจาก API
      console.error('No response received:', error.request);
      throw new Error('No response received from API');
    } else {
      // ข้อผิดพลาดทั่วไป
      console.error('Error fetching data:', error.message);
      throw new Error('An unexpected error occurred');
    }
  }
};

// ฟังก์ชันเพื่อเรียก API สำหรับดึงข้อมูลคอร์ส
export const fetchCoursesAPI = async (name,subject,category,generation,year,date,time,page,size) => {
  try {

      const account = JSON.parse(localStorage.getItem('account'));

       const response = await axiosInstance.post(URL+'/api/user/getAllCourse', {
          name: name,
          subject: subject,
          category: category,
          generation: generation,
          year:year,
          date: date,
          time: time,
          page: page,
          size: size,
      }, {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json'
      }});

      return response.data;
  } catch (error) {
      console.error('Error getAllUser in', error);
      throw error;
  }
};

export const fetchMyCoursesAPI = async (page,size) => {
  try {

      const account = JSON.parse(localStorage.getItem('account'));

      const response = await axiosInstance.post(URL+'/api/user/getMyCourse', {
          page: page,
          size: size,
      }, {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json'
      }});

      return response.data;
  } catch (error) {
      console.error('Error getAllUser in', error);
      throw error;
  }
};


// ฟังก์ชันเพื่อเรียก API สำหรับการดึงรายละเอียดคอร์ส
export const fetchCourseDetails = async (course_uid, accessToken,) => {
  try {
    const response = await axiosInstance.post(URL+'/api/user/getCourse', {
      course_uid: course_uid,
    }, {
      headers: {
        'Authorization': `${accessToken}`,
        'Content-Type': 'application/json',
      }
    });

    if (response.data.status) {
      return response.data;
    } else {
      throw new Error(response.data.error?.message || 'Unknown error');
    }
  } catch (error) {
    if (error.response) {
      console.error('API Error Response:', error.response.data || 'Unknown error');
      throw new Error(`API Error: ${error.response.data?.message || 'Unknown error'}`);
    } else {
      console.error('Error fetching course details:', error);
      throw error;
    }
  }
};


export const fetchUserScore = async (course_name, category, generation) => {
  try {
    // Log พารามิเตอร์ที่ส่งไป API
    console.log('Sending request with params:', { course_name, category, generation });

    // ดึงข้อมูล account จาก localStorage
    const account = JSON.parse(localStorage.getItem('account'));

    // ตรวจสอบว่า access_token มีอยู่ใน localStorage หรือไม่
    if (!account || !account.access_token) {
      throw new Error('Access token not found. Please log in again.');
    }

    // ส่งคำขอไปยัง API
    const response = await axiosInstance.post(URL + '/api/user/getUserScore', {
      course_name,
      category,
      generation
    }, {
      headers: {
        'authorization': `${account.access_token}`, // การส่ง access token
        'Content-Type': 'application/json',
      }
    });

    // เช็คข้อมูลที่ได้รับจาก API
    console.log('Response data:', response.data);

    return response.data; // ส่งข้อมูลกลับ
  } catch (error) {
    // จัดการกับข้อผิดพลาดที่เกิดขึ้น
    console.error('Error fetching user score:', error);
    throw error; // ส่งข้อผิดพลาดให้ฟังก์ชันที่เรียกใช้
  }
};




// ฟังก์ชันเพื่อเรียก API สำหรับการเรียนวิดีโอ
export const learnVideo = async (course_uid, video_uid, accessToken) => {
  try {
    const response = await axiosInstance.post(URL+'/api/user/learnVideo', {
      course_uid: course_uid,
      video_uid: video_uid,
    }, {
      headers: {
        'Authorization': `${accessToken}`,
        'Content-Type': 'application/json',
      }
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error('API Error Response:', error.response.data || 'Unknown error');
      throw new Error(`API Error: ${error.response.data?.message || 'Unknown error'}`);
    } else {
      console.error('Error learning video:', error);
      throw error;
    }
  }
};

// ฟังก์ชันเพื่อเรียก API สำหรับการสร้างความคิดเห็น
export const createComment = async (courseUid,replyCommentUid,message) => {
  try {

      const account = JSON.parse(localStorage.getItem('account'));

      const response = await axiosInstance.post(URL+'/api/user/createComment', {
          course_uid: courseUid,
          reply_comment_uid: replyCommentUid,
          message: message,
      }, {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json'
      }});

      return response.data;
  } catch (error) {
      console.error('Error createComment in', error);
      throw error;
  }
};


// ฟังก์ชันเพื่อส่งคำตอบ
export const submitAnswers = async (test_uid, answers, accessToken) => {
  try {
    const response = await axiosInstance.post(URL + '/api/user/takeTest', {
      test_uid: test_uid,
      answers: answers,
    }, {
      headers: {
        'Authorization': `${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    // ตรวจสอบว่า API ตอบกลับสถานะเป็น true หรือไม่
    if (response.data.status) {
      return response.data; // ส่งกลับข้อมูลที่ได้รับจาก API
    } else {
      throw new Error(response.data.error?.message || 'Unknown error');
    }
  } catch (error) {
    if (error.response) {
      // แสดงรายละเอียดข้อผิดพลาดที่ได้รับจาก API
      console.error('API Error Response:', error.response.data || 'Unknown error');
      throw new Error(`API Error: ${error.response.data?.error?.message || 'Unknown error'}`);
    } else {
      console.error('Error submitting answers:', error);
      throw new Error('Network or other error occurred');
    }
  }
};

export const fetchProfileDataAPI = async (accessToken) => {
  try {
    const response = await axiosInstance.get(URL+'/api/user/getProfile', {
      headers: {
        'Authorization': `${accessToken}`,
        'Content-Type': 'application/json'
      }
    });

    const data = response.data;

    if (data.status) {
      console.log('Profile Data:', data);
      return data.data?.account || {}; // คืนค่าข้อมูลโปรไฟล์
    } else {
      throw new Error(data.error?.message || 'Unknown error');
    }
  } catch (error) {
    if (error.response) {
      console.error('API Error Response:', error.response.data || 'Unknown error');
      throw new Error(`API Error: ${error.response.data?.message || 'Unknown error'}`);
    } else {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
};

export const editProfileAPI = async (formData) => {
  try {
    const account = JSON.parse(localStorage.getItem('account'));

    if (!account || !account.access_token) {
      throw new Error('Authorization token is missing');
    }

    // ส่งคำขอ POST ไปที่ API พร้อมข้อมูลจาก FormData
    const response = await axiosInstance.post(`${URL}/api/user/editProfile`, formData, {
      headers: {
        'Authorization': `${account.access_token}`,
        'Content-Type': 'multipart/form-data',
      }
    });

    // ตรวจสอบว่าการตอบกลับเป็นบวกหรือไม่
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to update profile');
    }
  } catch (error) {
    console.error('Error editing profile:', error.response ? error.response.data : error.message);
    throw error; // ส่งข้อผิดพลาดขึ้นไปให้ฟังก์ชันที่เรียกใช้
  }
};

export const forgotPasswordAPI = async (email) => {
  try {

      const account = JSON.parse(localStorage.getItem('account'));

      const response = await axiosInstance.post(URL+'/api/user/forgotPassword', {
        email: email,
      }, {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json'
      }});

      return response.data;
  } catch (error) {
      console.error('Error in forgotPasswordAPI:', error); 
      throw error;
  }
};

export const resetPasswordAPI = async (verifyToken, newPassword) => {
  try {
    const response = await axiosInstance.post(
      `${URL}/api/user/resetPassword`,
      {
        verify_token: verifyToken,
        password: newPassword,
      },
      {
        headers: {
          'content-type': 'application/json',
        },
      }
    );

    return response.data; 
  } catch (error) {
    // ปรับปรุงการจัดการข้อผิดพลาด
    if (error.response) {
      // เซิร์ฟเวอร์ตอบกลับด้วยสถานะที่ไม่ใช่ 2xx
      console.error('Error in resetPasswordAPI:', error.response.data);
      throw new Error(`Server responded with status ${error.response.status}: ${error.response.data.message || error.response.data}`);
    } else if (error.request) {
      // คำขอถูกส่งไปแต่ไม่ได้รับการตอบกลับ
      console.error('No response received from server:', error.request);
      throw new Error('No response received from server. Please try again later.');
    } else {
      // เกิดข้อผิดพลาดในการตั้งค่าคำขอ
      console.error('Error setting up the request:', error.message);
      throw new Error('Error setting up the request. Please try again later.');
    }
  }
};

//Show Calendar
export const getCourseCalendar = async (date) => {
  try {

      const account = JSON.parse(localStorage.getItem('account'));

      const response = await axiosInstance.post(URL+'/api/user/getCourseCalendar', {
          date: date
      }, {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json'
      }});

      return response.data;
  } catch (error) {
      console.error('Error getAllCalendar in', error);
      throw error;
  }
};

export const fetchHomeworkAPI = async (page,size,sort) => {
  try {
      const account = JSON.parse(localStorage.getItem('account'));

      const response = await axiosInstance.post(`${URL}/api/user/getUserHomework`, {
          page: page,
          size: size,
          sort: sort,
      }, {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json',
          },
      });

      return response.data;
  } catch (error) {
      console.error('Error fetching exams:', error);
      throw error;
  }
};

export const uploadFileAPI = async (homework_uid, files) => {
  try {
      const account = JSON.parse(localStorage.getItem('account'));

      const formData = new FormData();
      formData.append('homework_uid', homework_uid);

      files.forEach(file => {
        console.log('Uploading file:', file.name); // ตรวจสอบชื่อไฟล์
        formData.append('files', file);
    });
    

      const response = await axiosInstance.post(`${URL}/api/user/takeHomework`, formData, {
          headers: {
              'authorization': `${account?.access_token}`,
              'Content-Type': 'multipart/form-data',
          },
      });

      // แก้ไขการตรวจสอบการตอบสนอง
      if (response.data && response.data.status && response.data.data?.account_homework) {
          console.log('Exam submitted successfully:', response.data);
          return response.data.data.account_homework; // ส่งค่าที่ต้องการกลับ
      } else {
          console.error('Unexpected response format:', response.data);
          throw new Error('Unexpected response format');
      }
  } catch (error) {
      if (error.response) {
          console.error('Server responded with a status:', error.response.status);
          console.error('Response data:', error.response.data);
      } else {
          console.error('Error taking exam:', error);
      }
      throw error;
  }
};

export const TakeSpecialScoreAPI = async (special_uid, files) => {
  try {
      const account = JSON.parse(localStorage.getItem('account'));

      const formData = new FormData();
      formData.append('special_uid', special_uid);

      files.forEach(file => {
        console.log('Uploading file:', file.name); // ตรวจสอบชื่อไฟล์
        formData.append('files', file);
    });
    

      const response = await axiosInstance.post(`${URL}/api/user/takeSpecial`, formData, {
          headers: {
              'authorization': `${account?.access_token}`,
              'Content-Type': 'multipart/form-data',
          },
      });

      // แก้ไขการตรวจสอบการตอบสนอง
      if (response.data && response.data.status && response.data.data?.account_special) {
          console.log('Exam submitted successfully:', response.data);
          return response.data.data.account_special; // ส่งค่าที่ต้องการกลับ
      } else {
          console.error('Unexpected response format:', response.data);
          throw new Error('Unexpected response format');
      }
  } catch (error) {
      if (error.response) {
          console.error('Server responded with a status:', error.response.status);
          console.error('Response data:', error.response.data);
      } else {
          console.error('Error taking exam:', error);
      }
      throw error;
  }
};

export const deleteCommentAPI = async (comment_uid) => {
  try {
    const account = JSON.parse(localStorage.getItem('account'));

    const response = await axiosInstance.post(`${URL}/api/user/deleteComment`, 
    {
      comment_uid: comment_uid, // ส่ง comment_uid ใน request body
    }, 
    {
      headers: {
        'authorization': `${account?.access_token}`, // ใช้ access_token สำหรับการยืนยันตัวตน
        'content-type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error deleting comment:', error);
    throw error;
  }
};

export const getSurveyAPI = async (survey_uid) => {
  try {
    const account = JSON.parse(localStorage.getItem('account'));

    const response = await axiosInstance.post(URL+'/api/user/getSurvey', {
      survey_uid: survey_uid,
    }, {
      headers: {
        'Authorization': `${account?.access_token}`,
        'Content-Type': 'application/json',
      }
    });

    if (response.data.status) {
      return response.data;
    } else {
      throw new Error(response.data.error?.message || 'Unknown error');
    }
  } catch (error) {
    if (error.response) {
      console.error('API Error Response:', error.response.data || 'Unknown error');
      throw new Error(`API Error: ${error.response.data?.message || 'Unknown error'}`);
    } else {
      console.error('Error fetching course details:', error);
      throw error;
    }
  }
};

export const TakeSurveyAPI = async (survey_uid, answers, suggestion) => {
  try {
    // ดึงข้อมูลบัญชีผู้ใช้จาก localStorage
    const account = JSON.parse(localStorage.getItem('account'));

    // ส่งคำขอ POST ไปยัง API
    const response = await axiosInstance.post(`${URL}/api/user/takeSurvey`, {
      survey_uid: survey_uid,
      answers: answers,
      suggestion: suggestion || '', // หากไม่มีข้อเสนอแนะให้ส่งเป็นสตริงว่าง
    }, {
      headers: {
        'Authorization': `${account?.access_token}`, // ใช้ Bearer token สำหรับ Authorization
        'Content-Type': 'application/json',
      },
    });

    // ตรวจสอบสถานะของการตอบกลับจาก API
    if (response.data.status) {
      return response.data; // คืนค่าผลลัพธ์ที่ได้จาก API
    } else {
      throw new Error(response.data.error?.message || 'Unknown error');
    }
  } catch (error) {
    // จัดการข้อผิดพลาดที่เกิดขึ้น
    if (error.response) {
      console.error('API Error Response:', error.response.data || 'Unknown error');
      throw new Error(`API Error: ${error.response.data?.message || 'Unknown error'}`);
    } else {
      console.error('Error sending survey:', error);
      throw error; // คืนค่าข้อผิดพลาดที่เกิดขึ้น
    }
  }
};

// ฟังก์ชันเพื่อเรียก API สำหรับการสร้างความคิดเห็น
export const createCommentAll = async (replyCommentUid,message) => {
  try {

      const account = JSON.parse(localStorage.getItem('account'));

      const response = await axiosInstance.post(URL+'/api/user/createMainComment', {
          reply_comment_uid: replyCommentUid,
          message: message,
      }, {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json'
      }});

      return response.data;
  } catch (error) {
      console.error('Error createComment in', error);
      throw error;
  }
};

export const deleteCommentAll = async (main_comment_uid) => {
  try {
    const account = JSON.parse(localStorage.getItem('account'));

    const response = await axiosInstance.post(`${URL}/api/user/deleteMainComment`, 
    {
      main_comment_uid: main_comment_uid, // ส่ง comment_uid ใน request body
    }, 
    {
      headers: {
        'authorization': `${account?.access_token}`, // ใช้ access_token สำหรับการยืนยันตัวตน
        'content-type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error deleting comment:', error);
    throw error;
  }
};

export const getCommentAll = async (page, size) => {
  try {
      const account = JSON.parse(localStorage.getItem('account'));

      // ตรวจสอบว่า account และ access_token มีหรือไม่
      if (!account || !account.access_token) {
          console.error('No valid access token found');
          // อาจจะ redirect ไปหน้า login หรือทำการจัดการกรณีนี้
          return { status: false, message: 'No valid access token found' };
      }

      // ส่ง request ไปยัง API
      const response = await axiosInstance.post(
        `${URL}/api/user/getAllMainComment`, 
        { page, size }, // ข้อมูลที่จะส่งไป
        { 
          headers: {
            'Authorization': `${account.access_token}`, // ใส่ token ที่ถูกต้อง
            'Content-Type': 'application/json'
          }
        }
      );

      // ตรวจสอบว่า response มีข้อมูลที่ถูกต้องหรือไม่
      if (response.data && response.data.status === true) {
          return response.data;
      } else {
          console.error('API response error:', response.data);
          return { status: false, message: 'Failed to fetch comments' };
      }

  } catch (error) {
      console.error('Error in getCommentAll:', error);
      
      // ถ้าผิดพลาดจาก API เช่น token หมดอายุ (401 Unauthorized)
      if (error.response && error.response.status === 401) {
          console.error('Unauthorized, token may have expired');
          // ทำการจัดการกรณีนี้ เช่น redirect ไปหน้า login หรือรีเฟรช token ใหม่
      } else {
          console.error('Error message:', error.message);
      }

      // ส่งค่าผลลัพธ์ที่เป็นความผิดพลาด
      return { status: false, message: 'An error occurred while fetching comments' };
  }
};


export const getAllMainDocument = async (page, size) => {
  try {
      const account = JSON.parse(localStorage.getItem('account'));

      // ตรวจสอบว่า account และ access_token มีหรือไม่
      if (!account || !account.access_token) {
          console.error('No valid access token found');
          // อาจจะ redirect ไปหน้า login หรือทำการจัดการกรณีนี้
          return { status: false, message: 'No valid access token found' };
      }

      // ส่ง request ไปยัง API
      const response = await axiosInstance.post(
        `${URL}/api/user/getAllMainDocument`, 
        { page, size }, // ข้อมูลที่จะส่งไป
        { 
          headers: {
            'Authorization': `${account.access_token}`, // ใส่ token ที่ถูกต้อง
            'Content-Type': 'application/json'
          }
        }
      );

      // ตรวจสอบว่า response มีข้อมูลที่ถูกต้องหรือไม่
      if (response.data && response.data.status === true) {
          return response.data;
      } else {
          console.error('API response error:', response.data);
          return { status: false, message: 'Failed to fetch comments' };
      }

  } catch (error) {
      console.error('Error in getCommentAll:', error);
      
      // ถ้าผิดพลาดจาก API เช่น token หมดอายุ (401 Unauthorized)
      if (error.response && error.response.status === 401) {
          console.error('Unauthorized, token may have expired');
          // ทำการจัดการกรณีนี้ เช่น redirect ไปหน้า login หรือรีเฟรช token ใหม่
      } else {
          console.error('Error message:', error.message);
      }

      // ส่งค่าผลลัพธ์ที่เป็นความผิดพลาด
      return { status: false, message: 'An error occurred while fetching comments' };
  }
};

// ฟังก์ชันเพื่อเรียก API สำหรับดึงข้อมูลคอร์ส
export const getAllCourseComplete = async (name,subject,category,generation,year,date,time,page,size) => {
  try {

      const account = JSON.parse(localStorage.getItem('account'));

       const response = await axiosInstance.post(URL+'/api/user/getAllCourseComplete', {
          name: name,
          subject: subject,
          category: category,
          generation: generation,
          year:year,
          date: date,
          time: time,
          page: page,
          size: size,
      }, {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json'
      }});

      return response.data;
  } catch (error) {
      console.error('Error getAllUser in', error);
      throw error;
  }
};

// notification -------------------------------------------------------------------------
export const getAllNotification = async () => {
  try {

      const account = JSON.parse(localStorage.getItem('account'));

      const response = await axiosInstance.get(URL+'/api/user/getAllNotification', {
          headers: {
              'authorization': `${account?.access_token}`,
              'content-type': 'application/json'
      }});

      return response.data;
  } catch (error) {
      console.error('Error getAllNotification in', error);
      throw error;
  }
};

